import { render, staticRenderFns } from "./IconCommentWithNumber.vue?vue&type=template&id=25ed70b2&scoped=true&"
import script from "./IconCommentWithNumber.vue?vue&type=script&lang=js&"
export * from "./IconCommentWithNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed70b2",
  null
  
)

export default component.exports